import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Dashboard } from "./pages/Dashboard";
import RealReviews from "./pages/RealReviews";
import { Settings } from "./pages/Settings";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { AuthProvider } from "./contexts/AuthContext";
import { AiStatusProvider } from "./contexts/AiStatusContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import UniversalProductDetail from "./pages/UniversalProductDetail";
import ChoosePlan from "./pages/ChoosePlan";
import Profile from "./pages/Profile";
import Reviews from "./pages/Reviews";
import Stores from "./pages/Stores";
import { useAuth } from "./contexts/AuthContext";
import StoresList from "./pages/StoresList";
import { BillingProvider } from "./contexts/BillingContext";
import StoreProducts from "./pages/StoreProducts";
import StorePage from "./pages/StorePage";
import StoreReviews from "./pages/StoreReviews";
import Templates from "./pages/Templates";
import OrgUsers from "./pages/OrgUsers";

const OwnerOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (!user || user.role !== "owner") {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <BillingProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AiStatusProvider>
                  <Layout />
                </AiStatusProvider>
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="choose-plan" element={<ChoosePlan />} />
            <Route path="profile" element={<Profile />} />
            <Route path="real-reviews" element={<RealReviews />} />
            <Route path="reviews" element={<Reviews />} />
            <Route
              path="store-management"
              element={
                <OwnerOnly>
                  <Stores />
                </OwnerOnly>
              }
            />
            <Route path="stores" element={<StoresList />} />
            <Route path="stores/:storeId" element={<StorePage />}>
              <Route index element={<Navigate to="reviews" replace />} />
              <Route path="products" element={<StoreProducts />} />
              <Route path="reviews" element={<StoreReviews />} />
            </Route>
            <Route path="templates" element={<Templates />} />
            <Route path="org-users" element={<OrgUsers />} />
            <Route path="settings" element={<Settings />} />
            <Route
              path="products/:storeId/:productId"
              element={<UniversalProductDetail />}
            />
            <Route
              path="products/:platform/:idType/:value"
              element={<UniversalProductDetail />}
            />
            {/* removed ozon-products route */}
          </Route>
        </Routes>
      </BillingProvider>
    </AuthProvider>
  );
}

export default App;
